(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nspire-pdp-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nspire-pdp-guide')){
 customElements.define('nspire-pdp-guide',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();
  this.variants=JSON.parse(this.querySelector('[data-guide-variants]')?.textContent||'{}');
  this.addEventListener('click',event=>{
   const tab=event.target.closest('[data-guide-tab]');
   if(tab&&this.contains(tab))this.selectOz(tab.dataset.guideTab);
  },{signal:this.abort.signal});
  this.addEventListener('keydown',event=>{
   const tab=event.target.closest('[data-guide-tab]');
   if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
   event.preventDefault();
   const tabs=Array.from(this.querySelectorAll('[data-guide-tab]'));
   let index=tabs.indexOf(tab);
   if(event.key==='Home')index=0;
   else if(event.key==='End')index=tabs.length-1;
   else index=(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
   this.selectOz(tabs[index].dataset.guideTab);tabs[index].focus();
  },{signal:this.abort.signal});
  document.addEventListener('change',event=>{
   if(!(event.target instanceof HTMLSelectElement)||event.target.id!=='var1')return;
   const section=this.closest('[id^="shopify-section-"]');
   const radio=Array.from(section?.querySelectorAll('input[type="radio"]')||[]).find(input=>input.value===event.target.value);
   if(radio&&!radio.checked)radio.click();
  },{signal:this.abort.signal,capture:true});
  document.addEventListener('variant:update',event=>{
   if(String(event.detail?.data?.productId)!==this.dataset.productId)return;
   this.show(this.variants[String(event.detail?.resource?.id)]);
  },{signal:this.abort.signal});
 }
 disconnectedCallback(){this.abort?.abort();}
 selectOz(oz){
  const section=this.closest('[id^="shopify-section-"]');
  const picker=Array.from(section?.querySelectorAll('variant-picker')||[]).find(element=>element.dataset.productId===this.dataset.productId);
  const normalize=value=>value.toLowerCase().replace(/oz/g,'').trim();
  const radio=Array.from(picker?.querySelectorAll('input[type="radio"][data-fieldset-index="0"]')||[]).find(input=>normalize(input.value)===oz);
  if(radio&&!radio.disabled){
   this.show(oz);
   if(!radio.checked)radio.click();
   return;
  }
  const select=picker?.querySelector('select');
  const option=Array.from(select?.options||[]).find(item=>normalize(item.value)===oz);
  if(option&&!option.disabled){
   this.show(oz);
   if(select.value!==option.value){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
  }
 }
 show(oz){
  let found=false;
  this.querySelectorAll('[data-guide-oz]').forEach(panel=>{panel.hidden=panel.dataset.guideOz!==oz;if(!panel.hidden)found=true;});
  this.querySelectorAll('[data-guide-tab]').forEach(tab=>{const selected=tab.dataset.guideTab===oz;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;});
  const empty=this.querySelector('[data-guide-empty]');if(empty)empty.hidden=found;
 }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nspire-pdp-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nspire-pdp-videos')) {
    customElements.define('nspire-pdp-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previews = [...this.querySelectorAll('.nspire-pdp-videos__preview')];
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('.nspire-pdp-videos__player');
        this.toggle = this.querySelector('.nspire-pdp-videos__toggle');
        this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(navigator.connection?.saveData);
        this.inView = false;
        this.updateToggle();
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPreviews();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.querySelectorAll('.nspire-pdp-videos__card').forEach(card => {
          card.addEventListener('click', () => this.openVideo(card), options);
        });
        this.querySelector('.nspire-pdp-videos__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.closeVideo(), options);
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updateToggle();
          this.syncPreviews();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden && this.dialog.open) this.player.pause();
          this.syncPreviews();
        }, options);
      }
      updateToggle() {
        this.toggle.textContent = this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      }
      syncPreviews() {
        const shouldPlay = this.inView && !this.userPaused && !document.hidden && !this.dialog.open;
        this.previews.forEach(video => {
          video.muted = true;
          if (!shouldPlay) { video.pause(); return; }
          if (!video.getAttribute('src')) video.src = video.dataset.src;
          video.play().catch(() => {});
        });
      }
      openVideo(card) {
        if (!this.isConnected || this.dialog.open) return;
        this.opener = card;
        this.querySelector('.nspire-pdp-videos__athlete').textContent = card.dataset.athlete;
        this.player.setAttribute('aria-label', card.getAttribute('aria-label'));
        this.player.src = card.dataset.fullSrc;
        this.player.muted = false;
        this.player.volume = 1;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.syncPreviews();
        this.player.play().catch(() => {});
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
      closeVideo() {
        this.player.pause();
        this.player.removeAttribute('src');
        this.player.load();
        this.unlockScroll();
        this.syncPreviews();
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.previews?.forEach(video => video.pause());
        this.player?.pause();
        if (this.dialog?.open) this.dialog.close();
        this.unlockScroll();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
